import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'graphicManagerManifestContent',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: false,
  canRemove: false,
  isMultiSelectable:false,
  newButton:false,
  editURL:'',
  getURL:'liveScheduledEvents',
  updateURL:'',
  removeURL:'',
  deleteRecordText:"",


  sessionParams: [],

  emptyMessage: "You don't have any event scheduled.",
  fields: [
    {
      attributeName: 'uid',
      label: 'UID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'Live scheduled event uid.',
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'Live scheduled event name.',
    },
    {
      attributeName: 'liveId',
      label: 'Live Event ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'The Live linked to this scheduled event.',
    },
    {
      attributeName: 'live',
      label: 'Live Event Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'The Live linked to this scheduled event.',
    },
    {
      attributeName: 'startTime',
      label: 'Start Time',
      type: FormInputTypes.TIMESTAMP,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'Event start time',
    },
    {
      attributeName: 'endTime',
      label: 'End Time',
      type: FormInputTypes.TIMESTAMP,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'Event end stimated time.',
    },
  ],
};
